import { defineComponent as _defineComponent } from 'vue'
import FireOutbreakCantRelateReaction from './FireOutbreakCantRelateReaction.vue'
import FireOutbreakNotOccurredReaction from './FireOutbreakNotOccurredReaction.vue'
import FireOutbreakOccurredReaction from './FireOutbreakOccurredReaction.vue'
import FireOutbreakNotReacted from './FireOutbreakNotReacted.vue'
import { computed } from 'vue'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireOutbreakReaction.factory',
  props: {
    reaction: null,
    danger: { type: Boolean }
  },
  setup(__props: any) {

const { reaction, danger = false } = __props as {
	reaction?: FireOutbreakReactionEnum
	danger?: boolean
};



const _reaction = computed(() => {
	switch (reaction) {
		case FireOutbreakReactionEnum.POSITIVE:
			return FireOutbreakOccurredReaction
		case FireOutbreakReactionEnum.NEGATIVE:
			return FireOutbreakNotOccurredReaction
		case FireOutbreakReactionEnum.IMPOSSIBLE:
			return FireOutbreakCantRelateReaction
		default:
			return FireOutbreakNotReacted
	}
})

return { __sfc: true,_reaction }
}

})